import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../apiSetup/apiCall";

export const submitEditChargerData = createAsyncThunk(
  "submitEditCharger/fetchEditSubmitCharger",
  async ({ chargerId, payload }) => {
    try {
      const response = await api.post(
        `prometheus/charger/${chargerId}/edit/`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error Submitting Data:", error);
    }
  }
);

const SubmitEditChargerSlice = createSlice({
  name: "submitEditCharger",
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitEditChargerData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(submitEditChargerData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(submitEditChargerData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message;
      });
  },
});

export default SubmitEditChargerSlice.reducer;
